<template>
  <Nabvar />
  <Slider />

  <!--LINK FORMULARIOS-->
  <section>
    <div class="grid md:grid-cols-4 z-20 relative -mt-20">
      <div class="bg-otherblue p-4 border-2 border-white">
        <p class="text-white text-justify text-lg p-3">Citas en Línea</p>
        <p class="text-white text-left text-md p-2">
          Solicite su cita!, será programada via correo electrónico.
        </p>
        <button
          class="border-2 rounded-md py-1 px-5 text-left text-white hover:bg-white hover:text-otherblue"
          @click="$router.push('Citas-En-Linea')"
        >
          Solicitar cita
        </button>
      </div>
      <div class="bg-graynefro p-4 border-2 border-white">
        <p class="text-white text-justify text-lg p-0.5">Contáctenos</p>
        <p class="text-white text-left text-md p-2">
          Déjenos un mensaje, con gusto será atendido.
        </p>
        <button
          class="border-2 mt-5 rounded-md py-1 px-5 text-left text-white hover:bg-white hover:text-otherblue"
          @click="$router.push('Contactenos')"
        >
          Enviar Un Mensaje
        </button>
      </div>
      <div class="bg-otherblue p-4 border-2 border-white">
        <p class="text-white text-justify text-lg">PQR</p>
        <p class="text-white text-left text-md p-2">
          Su opinión es muy impórtate para nosotros.
        </p>
        <button
          class="border-2 mt-5 rounded-md py-1 px-5 text-left text-white hover:bg-white hover:text-otherblue"
          @click="$router.push('Pqr')"
        >
          Enviar PQR
        </button>
      </div>
      <div class="bg-graynefro p-4 border-2 border-white">
        <p class="text-white text-justify text-lg">Trabaja con Nosotros</p>
        <p class="text-white text-left text-md p-2">
          Déjenos su hoja de vida para evaluarla con nuestros vacantes.
        </p>
        <button
          class="border-2 mt-5 rounded-md py-1 px-5 text-left text-white hover:bg-white hover:text-otherblue"
          @click="$router.push('Trabaja-Con-Nosotros')"
        >
          Enviar Hoja de Vida
        </button>
      </div>
    </div>
  </section>
  <!--FIN LINK FORMULARIOS-->

  <!--Clinica Sagrada Familia-->
  <ClinicaSagradaFamilia />

  <!--Slider Ultima Tenologia-->
  <SliderUltimaTecnologia />

  <!--Citas en Línea-->
  <CitasEnLinea />

  <!-- Sección Noticias -->
  <section class="my-12 px-4">
    <h2 class="text-3xl font-bold mb-6 text-center">Noticias</h2>
    <div class="flex justify-center gap-6 flex-wrap">
      <div
        v-for="(noticia, index) in noticias"
        :key="index"
        class="max-w-sm bg-white rounded shadow-lg overflow-hidden"
      >
        <img
          :src="noticia.img"
          alt="Imagen Noticia"
          class="w-full h-72 object-cover"
        />
        <div class="p-4">
          <h3 class="text-xl font-semibold mb-2">{{ noticia.titulo }}</h3>
          <p class="text-gray-800 mb-3">{{ noticia.descripcion }}</p>
          <router-link
            :to="noticia.ruta"
            class="bg-otherblue text-white py-2 px-4 rounded hover:bg-gray-600 transition inline-block"
          >
            Ver más
          </router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Slider from "../components/Slider";
import ClinicaSagradaFamilia from "../components/ClinicaSagradaFamilia.vue";
import SliderUltimaTecnologia from "../components/SliderUltimaTecnologia.vue";
import CitasEnLinea from "./CitasEnLinea.vue";
// imports de Vision, Planes, Empresas si los usas

import imgNoticia1 from "@/assets/servicios/noticia-1/Noticia1.webp";
import imgNoticia2 from "@/assets/servicios/noticia-2/1.webp";
import imgNoticia3 from "@/assets/servicios/noticia-3/1.webp";

export default {
  components: {
    Slider,
    ClinicaSagradaFamilia,
    SliderUltimaTecnologia,
    CitasEnLinea,
    // Vision, Planes, Empresas si los usas
  },
  data() {
    return {
      noticias: [
        {
          img: imgNoticia1,
          titulo: "5 años liderando la salud en el Eje Cafetero",
          descripcion:
            "Clínica La Sagrada Familia, 5 años liderando la salud en el Eje Cafetero",
          ruta: "/Noticias/Noticia1",
        },
        {
          img: imgNoticia2,
          titulo: "Lanzamiento programa HOLEP",
          descripcion:
            "Clínica La Sagrada Familia lanza “Quindío Fluye”, el primer programa HOLEP en la región",
          ruta: "/Noticias/Noticia2",
        },
        {
          img: imgNoticia3,
          titulo: "Primer Implante de Válvula Aórtica",
          descripcion:
            "Primer Implante de Válvula Aórtica por Vía Endovascular (TAVI)",
          ruta: "/Noticias/Noticia3",
        },
      ],
    };
  },
};
</script>
